import { computed, ref } from 'vue'

import {
  UserPermission,
  useUpdateFileSettingsMutation,
} from '@/shared/graphql/legacy/generated'
import type { File } from '@/shared/graphql/router/graphql'
import { useUserStore } from '@/shared/stores/user'
import { updateFileInExplorerCache } from '@/features/explorer/utils/explorerCache'

export function useFilePrivacySettings(initialFile: File) {
  const userStore = useUserStore()

  const { mutate: updateFileSettings, loading } =
    useUpdateFileSettingsMutation()

  const file = ref({ ...initialFile })
  const isPrivate = ref(file.value.settings?.isPrivate ?? false)

  const isBasicUser = computed(
    () => !userStore.user?.permissions.includes(UserPermission.Pro)
  )

  const save = async () => {
    await updateFileSettings({
      input: {
        id: file.value.id,
        name: file.value.name,
        description: file.value.description ?? '',
        isPrivate: isPrivate.value,
      },
    })

    updateFileInExplorerCache(file.value.id, {
      settings: { __typename: 'FileSettings', isPrivate: isPrivate.value },
    })

    return {
      ...file.value,
      settings: { ...file.value.settings, isPrivate: isPrivate.value },
    }
  }

  return { isPrivate, isBasicUser, loading, save }
}
